import React from 'react';
import { AlertCircleIcon, ClockIcon, RefreshCwIcon } from 'lucide-react';
export function ObjectionsSection() {
  const objections = [{
    icon: AlertCircleIcon,
    objection: '"No soy bueno para la parte técnica…"',
    response: 'Justamente este curso es para eso: para explicarte todo como si estuviéramos sentados juntos frente a la compu, sin jerga innecesaria y paso a paso.',
    color: 'blue'
  }, {
    icon: ClockIcon,
    objection: '"No tengo mucho tiempo…"',
    response: 'Las clases son en vivo, pero tendrás grabaciones. Puedes verlas a tu ritmo, pero necesitas comprometer al menos unas horas a la semana para aplicar. Piensa: ¿cuánto vale aprender a traer clientes con anuncios, para no depender solo del boca a boca?',
    color: 'orange'
  }, {
    icon: RefreshCwIcon,
    objection: '"¿Y si Meta cambia la interfaz?"',
    response: 'Meta cambia cosas todo el tiempo, pero los fundamentos son los mismos. Te enseño los principios, no solo dónde está un botón. Así, cuando haya cambios, no te vas a sentir perdido.',
    color: 'purple'
  }];
  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    orange: 'bg-orange-100 text-orange-600',
    purple: 'bg-purple-100 text-purple-600'
  };
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-304">
      <div className="max-w-4xl mx-auto px-6" data-id="element-305">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-306">
          Objeciones típicas
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12" data-id="element-307">
          (y respuesta honesta)
        </p>

        <div className="space-y-8" data-id="element-308">
          {objections.map((item, idx) => {
          const Icon = item.icon;
          const colorClass = colorClasses[item.color as keyof typeof colorClasses];
          return <div key={idx} className="bg-gray-50 rounded-2xl p-8 border border-gray-200" data-id="element-309">
                <div className="flex items-start gap-4 mb-4" data-id="element-310">
                  <div className={`w-12 h-12 ${colorClass} rounded-xl flex items-center justify-center flex-shrink-0`} data-id="element-311">
                    <Icon className="w-6 h-6" data-id="element-312" />
                  </div>
                  <p className="text-xl font-bold text-gray-900 italic" data-id="element-313">
                    {item.objection}
                  </p>
                </div>
                <p className="text-lg text-gray-700 leading-relaxed ml-16" data-id="element-314">
                  {item.response}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}